import React, { useEffect, useState } from "react";
import { Badge, Button, Table } from "reactstrap";
import InfoPopup from "./InfoPopup";


export default function ReferedFriends(props) {
    const [uncollapsed, setUncollapsed] = useState([]);
    const [viewMoreClicked, setViewMoreClicked] = useState(false);
    const [viewLessClicked, setViewLessClicked] = useState(false);
    const [showPopUpHead, setShowPopUpHead] = useState(false);

    useEffect(() => {
        if (props.referrals && props.referrals.length > 3) {
            setUncollapsed([...props.referrals.slice(0, 3)]);
        } else {
            setUncollapsed([...props.referrals]);
        }
    }, []);

    const showMoreTx = () => {
        setViewLessClicked(true);
        setViewMoreClicked(false);
        setUncollapsed([...props.referrals]);
    };

    const showLessTx = () => {
        setViewMoreClicked(true);
        setViewLessClicked(false);
        setUncollapsed([...props.referrals.slice(0, 3)]);
    };

    const handleHeadInfoClick = () => {
        setShowPopUpHead(!showPopUpHead)
    }


    return (
        <div className="recent-tx">
            <div className="d-flex justify-content-between">
                <p className="font-weight-semi-bold header">Refered Friends</p>
            </div>
            <div className="table-wrapper">
                <Table striped className="trans-table">
                    <thead className="thead">
                        <tr style={{ backgroundColor: "#283A97" }}>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                #
                            </th>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                Email
                            </th>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody className="tbodyStyle">
                        {uncollapsed &&
                            uncollapsed.length &&
                            uncollapsed.map((item, index) => {
                                return (
                                    <tr className="text-center">
                                        <td className="noBorder">
                                            {index + 1}
                                        </td>
                                        <td className="noBorder">
                                            {item.email ? item.email : "--"}
                                        </td>
                                        <td className="text-capitalize noBorder">
                                            {item?.status === "done"
                                                ?
                                                <Badge
                                                    color="success"
                                                    className="p-2"
                                                >
                                                    {item.status}
                                                </Badge>
                                                :
                                                <Badge
                                                    color="warning"
                                                    className="p-2"
                                                >
                                                    Pending
                                                    <span
                                                        onClick={handleHeadInfoClick}
                                                        className="mdi mdi-information-outline ml-2"
                                                        style={{
                                                            cursor: "pointer",
                                                            fontSize: "15px",
                                                        }}
                                                    />
                                                </Badge>
                                            }
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </Table>
            </div>
            {!viewLessClicked && props?.referrals && props?.referrals.length > 3 ? (
                <div className="text-center mt-2">
                    <Button outline
                        color="secondary"
                        className="view-btn"
                        onClick={showMoreTx}>
                        View More
                        {/* <i className="mdi mdi-arrow-down-drop-circle-outline" /> */}
                    </Button>
                </div>
            ) : (
                ""
            )}
            {!viewMoreClicked && uncollapsed && uncollapsed.length > 3 ? (
                <div className="text-center mt-2">
                    <Button outline
                        color="secondary"
                        className="text-center view-btn"
                        onClick={showLessTx}>
                        View Less
                        {/* <i className="mdi mdi-arrow-up-drop-circle-outline" /> */}
                    </Button>
                </div>
            ) : (
                ""
            )}
            <InfoPopup 
                showPopUpText={showPopUpHead}
                toggleInfoPopup={handleHeadInfoClick}
                text={`Friends invited via email but not registered`}
            />
        </div>
    );
}
